import { Link, TableCell, useTheme } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { bodyCellPinnedStyle } from "routes/asset-register/plugins/regime-display/asset-view-table/asset-view-pinned-cell-styles"
import { navigate } from "lib/routes/navigate"
import { uniqueId } from "library/database/split-id.mjs"
import { usePlanRoot } from "lib/use-plan-root"

export function AssetRegisterBodyCell({ item: column, asset }) {
    const { columnState } = useBoundContext()
    const theme = useTheme()
    const regime = usePlanRoot()
    const isPinned = columnState?.pinnedField === column.field

    if (column.field === "tag") {
        return (
            <TableCell
                data-cy="asset-tag-cell-content"
                data-col="tag"
                sx={{ minWidth: 200, ...bodyCellPinnedStyle(isPinned, theme) }}
            >
                <Link onClick={editAsset}>{asset.tag}</Link>
            </TableCell>
        )
    }

    return (
        <TableCell
            align={column.align}
            data-cy={`asset-${column.field}-cell-content`}
            data-col={column.field}
            sx={bodyCellPinnedStyle(isPinned, theme)}
        >
            {(column.format ?? identity)(asset[column.field] ?? "")}
        </TableCell>
    )

    function editAsset() {
        const regimeParameter = regime?.id ? `?regime=${regime.id}` : ""
        navigate(`/app/asset/${uniqueId(asset.id)}${regimeParameter}`)
    }

    function identity(v) {
        return v
    }
}
